import store from "../../store/store";

export const componentKey = "CONTACT_DIRECTORY_SLICE";

const { actions } = store.reducerManager.add({
  key: componentKey,
  addedReducers: {
    setCloseAddContactDialog: (state, action) => {
      state.closeAddContactDialog = action.payload;
    },

    // Reducer to set the contact list data
    setContactDirectoryData: (state, action) => {
      state.contactDirectoryData = action.payload;
    },
  },
  initialReducerState: {
    closeAddContactDialog: false,
    contactDirectoryData: {},
  },
});

export const { setCloseAddContactDialog, setContactDirectoryData } = actions;
